import { Dropdown } from '../Dropdown/Dropdown';

/**
 * returns JSX for level select dropdown
 */
function LevelSelect<T extends number | string>({
  value,
  onChange,
  options,
  sticker = false,
}: {
  value: T | undefined;
  onChange: (t: T) => void;
  options: readonly {
    key: T;
    label: string;
  }[];
  sticker?: boolean;
}) {
  const items = options.map((item) => ({
    ...item,
    onClick: () => onChange(item.key),
  }));
  const findValues = items.find(({ key }) => key === value);
  const postword = sticker === true ? 'Stickers' : '';
  return (
    <Dropdown
      label={`${findValues?.label || 'Select level'} ${postword}`}
      menu={{ items }}
      key={value}
      overlayStyle={{ zIndex: '9999' }}
    ></Dropdown>
  );
}

export default LevelSelect;
